// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "app.status",
    name: "Status",
    homepage: "https://status.app/",
    image_id: "1e5fb93a-3a0a-40b9-8a86-b14a775aae00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/status-gateway-to-ethereum/id1178893006",
        android: "https://play.google.com/store/apps/details?id=im.status.ethereum",
        mac: "https://status.app/help/getting-started",
        windows: "https://status.app/help/getting-started",
        linux: "https://status.app/help/getting-started",
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "status-app://",
        universal: "https://status.app",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map